import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as alertifyjs from 'alertifyjs';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';
import { AuthService } from 'src/app/services/auth/auth.service';

/**
 * Preferencias del sistema (consola). Primera preferencia: vista de pagos por defecto.
 * Acceso restringido a OWNER vía guard de ruta.
 */
@Component({
  selector: 'app-preferencias',
  templateUrl: './preferencias.component.html',
  styleUrls: ['./preferencias.component.css']
})
export class PreferenciasComponent implements OnInit {

  activeTab = 'pagos';

  defaultPaymentsView: 'tabla' | 'classic' = 'classic';
  defaultFinancePaymentsView: 'tabla' | 'classic' = 'classic';
  loading = false;
  saving = false;
  savingFinance = false;

  constructor(
    private _appConfig: AppConfigService,
    private router: Router,
    public _auth: AuthService
  ) { }

  /** Permiso para cambiar la configuración de preferencias */
  get canConfig(): boolean {
    return this._auth.hasPermission('config.preferencias.config');
  }

  ngOnInit(): void {
    this.loadPreferences();
  }

  async loadPreferences() {
    this.loading = true;
    try {
      const prefs = await this._appConfig.getPreferences(true);
      this.defaultPaymentsView = prefs?.default_payments_view === 'tabla' ? 'tabla' : 'classic';
      this.defaultFinancePaymentsView = prefs?.default_finance_payments_view === 'tabla' ? 'tabla' : 'classic';
    } catch (error) {
      console.error(error);
    }
    this.loading = false;
  }

  async setPaymentsView(view: 'tabla' | 'classic') {
    if (!this.canConfig) return;
    if (this.saving || this.defaultPaymentsView === view) return;
    const previous = this.defaultPaymentsView;
    this.defaultPaymentsView = view;
    this.saving = true;
    try {
      await this._appConfig.updateDefaultPaymentsView(view);
      alertifyjs.success('Preferencia guardada');
    } catch (error) {
      console.error(error);
      this.defaultPaymentsView = previous;
      alertifyjs.error('No se pudo guardar la preferencia');
    }
    this.saving = false;
  }

  async setFinancePaymentsView(view: 'tabla' | 'classic') {
    if (!this.canConfig) return;
    if (this.savingFinance || this.defaultFinancePaymentsView === view) return;
    const previous = this.defaultFinancePaymentsView;
    this.defaultFinancePaymentsView = view;
    this.savingFinance = true;
    try {
      await this._appConfig.updateDefaultFinancePaymentsView(view);
      alertifyjs.success('Preferencia guardada');
    } catch (error) {
      console.error(error);
      this.defaultFinancePaymentsView = previous;
      alertifyjs.error('No se pudo guardar la preferencia');
    }
    this.savingFinance = false;
  }

  goBack() {
    this.router.navigate(['/console/parametros-sistema']);
  }
}
